module.exports = "/_next/static/images/ContactUsBlock-a89ac2e0bc163d9e70e168be9d56578d.jpg.webp";